module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"delivery receipt":"Delivery receipt","cancel":"Cancel","save":"Save","reset":"Reset"},"de":{"delivery receipt":"Lieferschein","cancel":"Abbrechen","save":"Speichern","reset":"Zurücksetzen"}}')
  delete Component.options._Ctor
}
